var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDcHomeResumendecadenascopia(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#87d7d6;stroke:#87d7d6;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31.76,7.07A23.24,23.24,0,0,0,10.22,21.44L8.85,19a2,2,0,0,0-.76-.8A2,2,0,0,0,5.3,19a2,2,0,0,0,0,2L9,27.62a2,2,0,0,0,1.19.94,2,2,0,0,0,1.51-.14l6.59-3.37h0a2,2,0,0,0,1-2.76,2,2,0,0,0-1.21-1,2,2,0,0,0-1.58.17l-2.42,1.25a19.21,19.21,0,0,1,17.7-11.57,18.88,18.88,0,1,1,0,37.76A19.14,19.14,0,0,1,13.11,34.34h0a2,2,0,0,0-3.37-1,2,2,0,0,0-.57,1.94A23.24,23.24,0,0,0,55,30,23.1,23.1,0,0,0,31.76,7.07ZM32,17.15h0a2,2,0,0,0-1.43.61A2,2,0,0,0,30,19.21V30h0a2,2,0,0,0,.76,1.58L37.51,37h0a2,2,0,0,0,1.49.44,2,2,0,0,0,1-3.6l-6-4.78V19.21h0a2,2,0,0,0-.58-1.46,2,2,0,0,0-1.46-.6Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDcHomeResumendecadenascopia);
export default __webpack_public_path__ + "static/media/DC_Home_Resumen de cadenas copia.60e34ff1877e0d8aabeb1ba71a2df8de.svg";
export { ForwardRef as ReactComponent };